export const UNKNOWN_ERROR_ERROR_CODE = 'api/unknown';

export default class ApiError extends Error {
  constructor(
    private readonly httpStatusCode: number,
    private readonly responseContent: unknown,
  ) {
    super(`API request failed: ${JSON.stringify(responseContent)}`);
  }

  getHttpStatusCode(): number {
    return this.httpStatusCode;
  }

  getErrorCode(): string {
    if (
      typeof this.responseContent !== 'object' ||
      this.responseContent === null ||
      !('message' in this.responseContent)
    ) {
      return UNKNOWN_ERROR_ERROR_CODE;
    }

    const message = this.responseContent.message;

    if (typeof message === 'undefined' || message === null) {
      return UNKNOWN_ERROR_ERROR_CODE;
    }

    if (typeof message !== 'string') {
      return message.toString();
    }

    return message;
  }
}
